import { Outlet } from 'react-router-dom';

import { EventInView, EventScope } from '@autopass-web/mochi-analytics/event';
import {
  CloseCircleFillIcon,
  ErrorCircleFillIcon,
} from '@autopass-web/mochi-icons';

import { Error } from '../components/error';

const ErrorRoutes = () => {
  return (
    <EventScope.Page page="交易結果頁">
      <Outlet />
    </EventScope.Page>
  );
};

const GeneralError = () => {
  return (
    <EventInView target="交易未預期錯誤">
      <Error
        message="發生未知錯誤，請重新嘗試。"
        title="未預期錯誤"
        icon={<ErrorCircleFillIcon color="#3193FD" width={70} height={70} />}
      />
    </EventInView>
  );
};

const StoreCancelled = () => {
  return (
    <EventInView target="交易取消">
      <Error
        message="您的交易已被商家取消，請重新啟動交易以完成付款。請注意：在繳費機台操作時，請勿掃描原 QR Code，需重新操作以生成新 QR Code。"
        title="交易已取消"
        icon={<ErrorCircleFillIcon color="#3193FD" width={70} height={70} />}
      />
    </EventInView>
  );
};

const UserCancelled = () => {
  return (
    <EventInView target="交易被用戶取消">
      <Error
        message="有需要時，您可以隨時重新操作"
        title="交易已取消"
        icon={<CloseCircleFillIcon color="#CCCCCC" width={70} height={70} />}
      />
    </EventInView>
  );
};

const Expired = () => {
  return (
    <EventInView target="交易逾期">
      <Error
        message="您的交易已逾時，請重新開始交易。"
        title="交易逾時"
        icon={<CloseCircleFillIcon color="#CCCCCC" width={70} height={70} />}
      />
    </EventInView>
  );
};

const NotFound = () => {
  return (
    <Error
      message="請重新嘗試。"
      title="找不到有效的交易"
      icon={<CloseCircleFillIcon color="#CCCCCC" width={70} height={70} />}
    />
  );
};

export {
  ErrorRoutes,
  Expired,
  GeneralError,
  NotFound,
  StoreCancelled,
  UserCancelled,
};
